


export namespace values {


    export function isTrue(value: string | null) {
        return value?.toLowerCase() === 'true';
    }
}